import React, { useState } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import { OpenSeaPort, Network } from 'opensea-js';

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import Settings from "./views/Settings";
import ExternalApi from "./views/ExternalApi";
import Onboarding from "./views/Onboarding";
import Nft from "./views/Nft";
import NftMarketplace from "./views/NftMarketplace";
import Rewards from "./views/Rewards";
import { useAuth0 } from "@auth0/auth0-react";
import * as Web3 from 'web3'
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

// web3
const provider = new Web3.providers.HttpProvider(`https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_API_KEY}`);
const web3 = new Web3(Web3.givenProvider || provider);

// opensea
const seaport = new OpenSeaPort(Web3.givenProvider || provider, {
  networkName: Network.Main,
  apiKey: process.env.REACT_APP_OPENSEA_API_KEY
});

const App = () => {
  const { isLoading, error, isAuthenticated, user, loginWithRedirect, buildAuthorizeUrl } = useAuth0();
  const [user1, setUser1] = useState({});
  const [isOnboarding, setIsOnboarding] = useState(false);

  async function fetchUser() {
    const userId = user.sub.split('|')[1];
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/userid/${userId}`, {
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method:'GET'
    });
    try {
      const cdUser = await response.json();
      setUser1(cdUser);      
    } catch(e){
      setIsOnboarding(true);
      history.push('/onboarding');
    }
  }
  
  React.useEffect(() => {
    if(isAuthenticated) {
      fetchUser();
    }
  }, [isAuthenticated]);

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  const params = new URLSearchParams(window. location. search)
  if(params.has('signup')) {
    buildAuthorizeUrl().then(str => window.location.assign(str + '&screen_hint=signup'));
    return null;
  }

  if(!isAuthenticated) {
    loginWithRedirect();
    return null;
  }

  if (!user1.sub && !isOnboarding) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar cdUser={user1} />
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact render={(props) => (<Home {...props} user={user1} />)}  />
            <Route path="/settings" render={(props) => (<Settings {...props} user={user1} setUser={setUser1} />)} />
            <Route path="/profile" render={(props) => (<Profile {...props} user={user1} setUser={setUser1} />)}/>
            <Route path="/nft/:tokenAddress/:tokenId" render={(props) => (<Nft {...props} seaport={seaport} />)}/>
            <Route path="/nft/:slug" render={(props) => (<NftMarketplace {...props} seaport={seaport} />)}/>
            <Route path="/nft" render={(props) => (<NftMarketplace {...props} seaport={seaport} />)}/>
            <Route path="/external-api" component={ExternalApi} />
            <Route path="/onboarding" render={(props) => (<Onboarding {...props} setUser={setUser1} isOnboarding={isOnboarding} />)} />
            <Route path="/rewards" render={(props) => (<Rewards {...props} />)}/>
          </Switch>
        </Container>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
